import { useTestClientResetMonitor } from '../../../hooks/useTestClientResetMonitor';
import { useTestClientResetStore } from '../../../store/useTestClientResetStore';
import { ActionFeedbackDialog } from '../../ActionFeedbackDialog/ActionFeedbackDialog';

const reloadPage = () => window.location.reload();

// Fica montado com o NavBar (o menu do usuário fecha e desmonta): acompanha o reset e avisa quando termina.
export const TestClientResetMonitor = ({ login }: { login?: string }) => {
  useTestClientResetMonitor(login);
  const finishedReset = useTestClientResetStore(state => state.finishedReset);
  const setFinishedReset = useTestClientResetStore(state => state.setFinishedReset);

  if (!finishedReset) return null;

  const succeeded = finishedReset.conclusion === 'success';
  const closeDialog = () => setFinishedReset(null);

  return (
    <ActionFeedbackDialog
      open
      type={succeeded ? 'success' : 'error'}
      title={succeeded ? 'Dados de teste resetados' : 'O reset dos dados de teste falhou'}
      description={
        succeeded
          ? 'O cliente voltou ao estado inicial da massa da task. Recarregue a página para ver os dados novos.'
          : 'Os dados podem ter ficado como estavam. Tente de novo pelo menu do usuário ou avise quem preparou o cliente.'
      }
      primaryAction={succeeded ? { label: 'Recarregar a página', onClick: reloadPage } : undefined}
      secondaryAction={{ label: 'Fechar', onClick: closeDialog }}
    />
  );
};
